import React from "react";

import "rc-rate/assets/index.css";
import { useState } from "react";
import ReactDOM from "react-dom";
import EditProductModal from "./EditProductModal";
import sendRequest from "hooks/useAxios";

import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import SingleSaleDetail from "components/SingleProduct/SingleSaleDetail";
import GroupSaleDetail from "components/SingleProduct/GroupSaleDetail";

function DetailProduct({ product, isAdmin, setUpdateProduct }) {
  // colors of product
  const navigate = useNavigate();
  const [saleType, setSaleType] = useState("single");
  const adminButtons = (
    <div>
      <button
        className="btn bg-success text-light"
        data-bs-toggle="modal"
        data-bs-target="#editProductModal"
      >
        ویرایش
      </button>
      <button
        className="btn bg-danger text-light mx-1"
        onClick={() => {
          Swal.fire({
            icon: "warning",
            title: "آیا از حذف این محصول مطمئن هستید؟",
            showCancelButton: true,
            cancelButtonText: "انصراف",
            confirmButtonText: "حذف",
            cancelButtonColor: "#EF394E",
            confirmButtonColor: "#439B58",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              sendRequest("deleteproduct", { productId: product.id }).then(
                ({ data }) => {
                  if (data.status == 1) {
                    Swal.fire({
                      title: "محصول با موفقیت حذف شد.",
                      showConfirmButton: false,
                      timer: 2000,
                    });
                    navigate("/show-case", { replace: true });
                  }
                }
              );
            }
          });
        }}
      >
        حذف
      </button>
    </div>
  );
  const returnSaleSection = () => {
    console.log("product :", product);

    if (saleType == "single" && product.best_once_seller?.length)
      return (
        <SingleSaleDetail
          isAdmin={isAdmin}
          product={product}
        ></SingleSaleDetail>
      );
    else if (saleType == "group" && product.best_group_seller?.length) {
      return (
        <GroupSaleDetail isAdmin={isAdmin} product={product}></GroupSaleDetail>
      );
    } else {
      return (
        <p className="mt-3 fw-bolder">
          در حال حاضر فروش این کالا متوقف شده است.
        </p>
      );
    }
  };

  // price and counter section

  return (
    <div className="ms-5 ">
      <div className="d-flex flex wrap justify-content-between">
        <h5 className="my-3 ">{product.title}</h5>
        {isAdmin && adminButtons}
      </div>

      <p className="my-2">{product.description}</p>

      <div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            defaultChecked
            onChange={(e) => {
              setSaleType("single");
            }}
          />
          <label className="form-check-label" htmlFor="inlineRadio1">
            خرید تکی
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            onChange={(e) => {
              setSaleType("group");
            }}
          />
          <label className="form-check-label" htmlFor="inlineRadio2">
            خرید گروهی
          </label>
        </div>
      </div>
      {returnSaleSection()}
      {/* edit modal */}
      {ReactDOM.createPortal(
        <EditProductModal
          product={product}
          setUpdateProduct={setUpdateProduct}
        />,
        document.getElementById("modals")
      )}
    </div>
  );
}

export default DetailProduct;
